import { useEffect, useState } from 'react';
import { ChangeAlertCallbackType } from '../../../Root';
import { useAFBFunction } from '../../../customwidgets/afb-company-admin/hooks/useAFBFunction';

export const useGetAccountNumbers = (open: boolean, changeAlert: ChangeAlertCallbackType) => {
    const { handleGetAccounts } = useAFBFunction(changeAlert);

    const [zPos, setZPos] = useState(45);
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);

    const onHandleChange = (e) => {
        if (!isNaN(e.target.value)) {
            let accounts = e.target.value;
            setSearch(e.target.value);
            if (accounts <= 0 || accounts > 10) {
                setError(true);
                setDisabled(true);
            } else {
                setError(false);
                setDisabled(false);
            }
        }
    };

    const onHandleGetAccounts = async () => {
        setLoading(true);
        setZPos(-1);

        let payload = {
            account_number_total_count: search,
        };
        let resp = await handleGetAccounts(payload);
        if (resp) {
            setData(resp);
            setSearch('');
            setDisabled(true);
        } else {
            setData([]);
        }

        setZPos(45);
        setLoading(false);
    };

    useEffect(() => {
        if (!open) {
            setData([]);
            setSearch('');
            setError(false);
            setDisabled(true);
        }
    }, [open]);

    return {
        zPos,
        data,
        error,
        search,
        loading,
        disabled,
        onHandleChange,
        onHandleGetAccounts,
    };
};
